import PropTypes from 'prop-types';
import { useEnv } from '@adsk/bim360-matrix-react-api/es/contexts/env';
import { REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import React from 'react';
/**
 * Inject isFedRAMP by Region from ENV provider
 */
const IsFedrampRegion = ({ isFedRAMP, children }) => {
  const env = useEnv();
  const isFedrampRegion = isFedRAMP || (env && env.region === REGIONS.FEDRAMP);

  return <React.Fragment>{children({ isFedRAMP: isFedrampRegion })}</React.Fragment>;
};

IsFedrampRegion.propTypes = {
  /**
   * Flag for FedRAMP region modifications
   */
  isFedRAMP: PropTypes.bool,
  /**
   * We expect to get function as a children that use isFedRAMP prop : ({ isFedRAMP }) => {}
   */
  children: PropTypes.func
};

export default IsFedrampRegion;
